import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { WHATSAPP_URL } from './config';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden" data-id="element-92">
      {/* Decorative Background Elements */}
      <div className="absolute top-1/4 left-10 w-72 h-72 bg-nova-cyan/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob" data-id="element-93"></div>
      <div className="absolute top-1/3 right-10 w-72 h-72 bg-blue-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000" data-id="element-94"></div>
      <div className="absolute -bottom-8 left-1/2 w-72 h-72 bg-purple-200/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-4000" data-id="element-95"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10 w-full" data-id="element-96">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-97">
          {/* Left Content */}
          <div className="max-w-2xl" data-id="element-98">
            <FadeIn delay={0.1} data-id="element-99">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/60 backdrop-blur-md border border-white/60 text-sm font-medium text-nova-dark mb-8 shadow-sm" data-id="element-100">
                <span className="flex h-2 w-2 rounded-full bg-nova-cyan" data-id="element-101"></span>
                Odontología de vanguardia en Neuquén
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-102">
              <h1 className="text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter text-nova-dark leading-[1.1] mb-6" data-id="element-103">
                La Ciencia <br data-id="element-104" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-nova-cyan to-blue-500" data-id="element-105">
                  de tu Sonrisa
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-106">
              <p className="text-xl text-nova-gray mb-10 leading-relaxed max-w-lg" data-id="element-107">
                Experimenta el futuro del cuidado dental. Tecnología premium,
                confort absoluto y resultados extraordinarios en un ambiente
                diseñado para tu tranquilidad.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="flex flex-col sm:flex-row gap-4" data-id="element-108">
              <Button href={WHATSAPP_URL} variant="primary" icon={<ArrowRightIcon size={18} data-id="element-110" />} data-id="element-109">
                Reservar Turno
              </Button>
              <Button href="#servicios" variant="ghost" data-id="element-111">
                Conocer Más
              </Button>
            </FadeIn>

            {/* Stats */}
            <FadeIn delay={0.6} className="mt-16 pt-10 border-t border-nova-gray/10 grid grid-cols-3 gap-6" data-id="element-112">
              <div data-id="element-113">
                <div className="text-3xl font-black text-nova-dark" data-id="element-114">15+</div>
                <div className="text-sm text-nova-gray mt-1" data-id="element-115">Años de exp.</div>
              </div>
              <div data-id="element-116">
                <div className="text-3xl font-black text-nova-dark" data-id="element-117">10k+</div>
                <div className="text-sm text-nova-gray mt-1" data-id="element-118">Sonrisas</div>
              </div>
              <div data-id="element-119">
                <div className="text-3xl font-black text-nova-dark flex items-center gap-1" data-id="element-120">
                  98%{' '}
                  <StarIcon size={20} className="text-yellow-400 fill-yellow-400" data-id="element-121" />
                </div>
                <div className="text-sm text-nova-gray mt-1" data-id="element-122">Satisfacción</div>
              </div>
            </FadeIn>
          </div>

          {/* Right Content - Abstract Floating Cards */}
          <div className="hidden lg:block relative h-[600px]" data-id="element-123">
            <FadeIn delay={0.5} direction="left" className="absolute top-10 right-0 w-80 glass-panel p-6 z-20" data-id="element-124">
              <div className="w-12 h-12 rounded-2xl bg-nova-cyan/20 flex items-center justify-center mb-4" data-id="element-125">
                <StarIcon className="text-nova-cyan" size={24} data-id="element-126" />
              </div>
              <h3 className="text-lg font-bold text-nova-dark mb-2" data-id="element-127">
                Diseño de Sonrisa 3D
              </h3>
              <p className="text-sm text-nova-gray" data-id="element-128">
                Visualiza tu resultado final antes de comenzar el tratamiento
                con nuestra tecnología de escaneo.
              </p>
            </FadeIn>

            <FadeIn delay={0.7} direction="up" className="absolute bottom-20 left-0 w-72 glass-panel p-6 z-30" data-id="element-129">
              <div className="flex items-center gap-4 mb-4" data-id="element-130">
                <div className="w-12 h-12 rounded-full bg-gray-200 overflow-hidden" data-id="element-131">
                  <img src="https://i.pravatar.cc/150?img=32" alt="Paciente" className="w-full h-full object-cover" data-id="element-132" />
                </div>
                <div data-id="element-133">
                  <div className="text-sm font-bold text-nova-dark" data-id="element-134">
                    María L.
                  </div>
                  <div className="flex text-yellow-400" data-id="element-135">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={12} className="fill-current" data-id="element-136" />)}
                  </div>
                </div>
              </div>
              <p className="text-sm text-nova-gray italic" data-id="element-137">
                "Cero dolor y una atención de primer nivel. Me cambiaron la
                vida."
              </p>
            </FadeIn>

            {/* Main Image Placeholder */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1,
            delay: 0.3
          }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[500px] rounded-[3rem] overflow-hidden shadow-2xl z-10" data-id="element-138">
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Clínica Dental Moderna" className="w-full h-full object-cover" data-id="element-139" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-140"></div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}